module.exports = __webpack_public_path__ + "img/speed-2.a0824363.png";